(function() {
  var style = document.createElement('style');
  style.textContent = `
    .ss-will-animate {
      opacity: 0;
      transform: translateY(24px);
      transition: opacity 0.6s ease, transform 0.6s ease;
    }
    .ss-will-animate.ss-animate-in {
      opacity: 1;
      transform: translateY(0);
    }
  `;
  document.head.appendChild(style);

  function initAnimations() {
    var sections = document.querySelectorAll(
      '.shopify-section:not(#shopify-section-header):not(#shopify-section-footer):not(#shopify-section-announcement-bar)'
    );

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('ss-animate-in');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.05, rootMargin: '0px 0px -40px 0px' });

    sections.forEach(function(el) {
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight) {
        // Already visible — no animation needed, just show
        el.classList.add('ss-animate-in');
      } else {
        // Below fold — mark hidden and observe
        el.classList.add('ss-will-animate');
        observer.observe(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAnimations);
  } else {
    initAnimations();
  }
})();
